// extracted by mini-css-extract-plugin
export default {"experience-card":"style_experience-card__5-3G3","card-left":"style_card-left__qY6N-","card-right":"style_card-right__Lh8Wp"};